export function Article() {
  return <div></div>
}
